import { Button } from 'antd';
import React, { CSSProperties, FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ImageGuide from '@/assets/images/page/image-guide-logo-text.react.svg?react';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { useStores } from '@/presentation/store';
import { onUpgrade } from './auth';
import styles from './auth.module.scss';

export interface GuideUpgradePageCardProps {
  style?: CSSProperties
  reportGuideType?: string
  reportScene?: string
  reportField?: string
}

export const GuideUpgradePageCard: FC<GuideUpgradePageCardProps> = (props) => {
  const { t } = useTranslation();
  const { pgid } = useStores().LayoutStore;
  const { reportScene, reportGuideType, reportField } = props;
  useEffect(() => {
    reportClick(props.reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
      from: pgid,
      param3: props.reportGuideType,
      param4: props.reportField,
    });
  }, [reportScene]);

  const reportProps = { reportScene, pgid, reportGuideType, reportField };
  return (
    <div
    className={styles.guideUpgradePage}
    style={props.style}
    >
      <div
        style={{
          marginTop: '56px',
          fontSize: '24px',
          fontFamily: 'PingFang SC',
          lineHeight: '28px',
        }}
      >
        {t('体验产品不支持此功能。如需使用，请')}
        <a onClick={() => onUpgrade(reportProps)} style={{ cursor: 'pointer' }}>
          {t('购买资源包')}
        </a>{t('，升级为付费产品后再使用。')}
      </div>
      <Button
        type="primary"
        style={{
          marginTop: '16px',
          marginBottom: '7px',
          fontSize: '14px',
          lineHeight: '22px',
        }}
        onClick={() => onUpgrade(reportProps)}
      >
        {t('购买资源包')}
      </Button>
      <ImageGuide style={{ position: 'absolute',
        top: '240px', transform: 'scale(1.2)'  }}/>
    </div>
  );
};

